var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMuses28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5857 2H26V13.4142L19.4142 20H9.41417L3.41417 26H2V24.5857L5.99995 20.5858V10.5858L14.5857 2ZM7.99995 18.5858L9.99995 16.5858V14L11 13L12 14V14.5858L14 12.5858V8L15 7L16 8V10.5858L19.5857 7H21V8.41417L11.4142 18H18.5857L21.5857 15H20L19 14L20 13H23.5857L24 12.5858V4H15.4142L7.99995 11.4142V18.5858Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMuses28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;